export const deriveStateNumber = state => {
    return state.resources.number + 1;
}


// WEBPACK FOOTER //
// ./src/js/store/getters.js